module.exports = __webpack_public_path__ + "src/img/previewBg.afb65b6e.png";